import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  const typeLabel = movie.type === "movie" ? "电影" : "电视剧";
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 海报 影视内容 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-900/85 text-background-50 text-xs font-medium">
          {typeLabel}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold flex items-center gap-1">
          <i className="ri-fire-fill text-[10px]" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-600 flex items-center gap-2 flex-wrap">
          <span>{movie.year}</span>
          <span className="w-px h-3 bg-background-300"></span>
          <span className="truncate">{movie.region}</span>
        </p>
        <div className="flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((g) => (
            <span key={g} className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px]">
              {g}
            </span>
          ))}
        </div>
        <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{movie.summary}</p>
      </div>
    </Link>
  );
}